// extracted by mini-css-extract-plugin
export default {"grid":"HighlightGrid_grid__J37dw"};